"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.removeAssignedLoanTapeArtifacts = exports.addAssignedLoanTapeArtifacts = exports.materializeChangeset = exports.materializeChangesetForMasterLoanTapeType = exports.materializeChangesetForPreassignedArchetypes = exports.materializeAssignedLoanTapeChangeset = exports.createAssignedLoanTapeArtifact = exports.getAssociatedReceivableResponseTapes = void 0;
const lodash = __importStar(require("lodash"));
const remeda_1 = require("remeda");
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const helpers_1 = require("./helpers");
const loanTapeDependencies_1 = require("./loanTapeDependencies");
const mesh = __importStar(require("./mesh"));
const preview = __importStar(require("./receivableResponseTapePreview"));
const { cloneDeep } = lodash;
const getAssociatedReceivableResponseTapes = ({ receivableResponseTapes, dataTapeDependencies, masterLoanTapeId, }) => {
    const filterAdapter = (rrtIds) => (0, remeda_1.filter)(receivableResponseTapes, (rrt) => rrtIds.includes(rrt.id));
    return (0, remeda_1.pipe)(dataTapeDependencies, (0, remeda_1.filter)((dep) => dep.inputArtifactId === masterLoanTapeId), (0, remeda_1.map)((dep) => dep.outputArtifactId), filterAdapter);
};
exports.getAssociatedReceivableResponseTapes = getAssociatedReceivableResponseTapes;
const createAssignedLoanTapeArtifact = ({ masterLoanTape, creditFacilitySlug, }) => {
    (0, common_1.finleyAssert)(masterLoanTape.loanProductSlug, 'loanProductSlug must exist for masterLoanTape');
    return {
        id: (0, uuid_1.v4)(),
        type: 'assignedLoanTape',
        configuration: {}, // no configuration needed
        loanProductSlug: masterLoanTape.loanProductSlug,
        creditFacilitySlug,
        artifactDocumentId: masterLoanTape.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `assignedLoanTape_${masterLoanTape.loanProductSlug}_${creditFacilitySlug}`, // unique for assignedLoanTape
    };
};
exports.createAssignedLoanTapeArtifact = createAssignedLoanTapeArtifact;
const materializeAssignedLoanTapeChangeset = ({ masterLoanTape, receivableResponseTape, dataTapeDependencies, }) => {
    const { creditFacilitySlug, artifactSlug } = receivableResponseTape;
    (0, common_1.finleyAssert)(creditFacilitySlug, `creditFacilitySlug must defined for receivable response tape ${artifactSlug}`);
    const assignedLoanTape = (0, exports.createAssignedLoanTapeArtifact)({
        masterLoanTape,
        creditFacilitySlug,
    });
    const dataTapeDependency = utils.getDependency({
        outputArtifactId: receivableResponseTape.id,
        inputArtifactId: masterLoanTape.id,
        dataTapeDependencies,
    });
    const { outputDependency, inputDependency } = utils.insertDependency({
        dataTapeDependency,
        insertId: assignedLoanTape.id,
    });
    return {
        assignedLoanTape,
        outputDependency,
        inputDependency,
        dependencyForRemoval: dataTapeDependency,
    };
};
exports.materializeAssignedLoanTapeChangeset = materializeAssignedLoanTapeChangeset;
// One assignedLoanTape changeset per masterLoanTape -> receivableResponseTape
// edge, for the masterLoanTapes of `loanProductSlugs`.
const materializeAssignedLoanTapeChangesets = ({ dataTapeDependencies, dataTapes, loanProductSlugs, }) => {
    const masterLoanTapes = utils
        .filterMasterLoanTapes({ dataTapes })
        .filter((dataTape) => lodash.includes(loanProductSlugs, dataTape.loanProductSlug));
    const receivableResponseTapes = utils.filterReceivableResponseTapes({
        dataTapes,
    });
    const changesets = masterLoanTapes.flatMap((masterLoanTape) => (0, exports.getAssociatedReceivableResponseTapes)({
        receivableResponseTapes,
        dataTapeDependencies,
        masterLoanTapeId: masterLoanTape.id,
    }).map((receivableResponseTape) => (0, exports.materializeAssignedLoanTapeChangeset)({
        masterLoanTape,
        receivableResponseTape,
        dataTapeDependencies,
    })));
    return { masterLoanTapes, changesets };
};
// for preassigned and preassignedMaster
const materializeChangesetForPreassignedArchetypes = (input) => {
    const { changesets } = materializeAssignedLoanTapeChangesets(input);
    return {
        dependenciesForInsert: changesets.flatMap(({ outputDependency, inputDependency }) => [
            outputDependency,
            inputDependency,
        ]),
        dataTapesForInsert: changesets.map(({ assignedLoanTape }) => assignedLoanTape),
        dependenciesForRemoval: changesets.map(({ dependencyForRemoval }) => dependencyForRemoval),
    };
};
exports.materializeChangesetForPreassignedArchetypes = materializeChangesetForPreassignedArchetypes;
const materializeChangesetForMasterLoanTapeType = (input) => {
    // creates assignedLoanTape artifacts, and assignedLoanTape<>receivableResponseTape deps
    // and the masterLoanTape<>receivableResponseTape edges to remove
    const { masterLoanTapes, changesets } = materializeAssignedLoanTapeChangesets(input);
    const { receivableResponseTapePreview, receivableResponseTapePreviewDependencies, } = preview.materializeReceivableResponseTapePreviewChangeset({
        loanProductSlugs: input.loanProductSlugs,
        masterLoanTapes,
    });
    return {
        // Note: unlike preassignedMasterLoanTape and preassignedLoanTape, we don't
        // push the inputDependency node, which represents a masterLoanTape<>assignedLoanTape edge
        // this should NOT exist in the masterLoanTape BBPL flow
        dependenciesForInsert: [
            ...changesets.map(({ outputDependency }) => outputDependency),
            ...receivableResponseTapePreviewDependencies,
        ],
        dataTapesForInsert: [
            ...changesets.map(({ assignedLoanTape }) => assignedLoanTape),
            receivableResponseTapePreview,
        ],
        dependenciesForRemoval: changesets.map(({ dependencyForRemoval }) => dependencyForRemoval),
    };
};
exports.materializeChangesetForMasterLoanTapeType = materializeChangesetForMasterLoanTapeType;
const materializeChangeset = ({ dataTapeDependencies, dataTapes, loanTapeType, loanProductSlugs, }) => {
    switch (loanTapeType) {
        case 'masterLoanTape':
            return (0, exports.materializeChangesetForMasterLoanTapeType)({
                dataTapeDependencies,
                dataTapes,
                loanProductSlugs,
            });
        case 'preassignedLoanTape':
        case 'preassignedMasterLoanTape':
            return (0, exports.materializeChangesetForPreassignedArchetypes)({
                dataTapeDependencies,
                dataTapes,
                loanProductSlugs,
            });
        default:
            return (0, common_1.finleyAssertUnreachable)(loanTapeType);
    }
};
exports.materializeChangeset = materializeChangeset;
/**
 * Adds assigned loan tape artifacts + dependencies by splicing an assignedLoanTape
 * onto each masterLoanTape -> receivableResponseTape edge.
 *
 *                        *** Current ***
 * +----------------+      +------------------------+
 * | masterLoanTape | ---> | receivableResponseTape |
 * +----------------+      +------------------------+
 *
 *          *** Revised (preassigned / preassignedMaster) ***
 * +----------------+      +------------------+      +------------------------+
 * | masterLoanTape | ---> | assignedLoanTape | ---> | receivableResponseTape |
 * +----------------+      +------------------+      +------------------------+
 *
 *          *** Revised (masterLoanTape archetype) ***
 * The masterLoanTape<>assignedLoanTape edge is intentionally NOT created (it must
 * not exist in the masterLoanTape BBPL flow); a shared receivableResponseTapePreview
 * is added and fed by each masterLoanTape instead.
 * +------------------+      +------------------------+
 * | assignedLoanTape | ---> | receivableResponseTape |
 * +------------------+      +------------------------+
 *
 * +----------------+      +-------------------------------+
 * | masterLoanTape | ---> | receivableResponseTapePreview |
 * +----------------+      +-------------------------------+
 */
const addAssignedLoanTapeArtifacts = ({ dbGraph, loanTapeTypeMap, }) => {
    let dataTapeDependencies = cloneDeep(dbGraph.dataTapeDependencies);
    const dataTapes = cloneDeep(dbGraph.dataTapes);
    const lpCfSlugGroupingsWithType = mesh.getLpCfSlugGroupingsWithTypeFromMasterLoanTapes({
        dbGraph: {
            dataTapes,
            dataTapeDependencies,
        },
        loanTapeTypeMap,
    });
    (0, remeda_1.forEach)(lpCfSlugGroupingsWithType, (grouping) => {
        const { loanTapeType, loanProductSlugs } = grouping;
        // master loan tape archetype (master and preassignedMaster) should only have
        // 1 instance of master loan tape artifact per loan product.  However, preassignedLoanTape
        // types can have multiple master loan tape artifact per loan product.  While this assertion is not needed for attach,
        // it is a required property to be able to properly detach synthetic nodes
        if (loanTapeType !== 'preassignedLoanTape') {
            const masterLoanTapes = utils.filterMasterLoanTapes({ dataTapes });
            const masterLoanTapeSlugs = masterLoanTapes.map(({ artifactSlug }) => artifactSlug);
            const uniqLoanProductSlugs = (0, remeda_1.pipe)(masterLoanTapes, (0, remeda_1.map)(({ loanProductSlug }) => loanProductSlug), (0, remeda_1.uniq)());
            (0, common_1.finleyAssert)(uniqLoanProductSlugs.length === masterLoanTapes.length, `Only 1 master loan tape per loanProductSlug is allowed for MasterLoanTape and PreassignedMasterLoanTape types: uniqLoanProductSlugs: ${uniqLoanProductSlugs.join(', ')}, masterLoanTapes: ${masterLoanTapeSlugs.join(', ')}`);
        }
        const { dependenciesForInsert, dataTapesForInsert, dependenciesForRemoval, } = (0, exports.materializeChangeset)({
            dataTapeDependencies,
            dataTapes,
            loanTapeType,
            loanProductSlugs,
        });
        (0, remeda_1.forEach)(dependenciesForInsert, (dep) => {
            dataTapeDependencies.push(dep);
        });
        (0, remeda_1.forEach)(dataTapesForInsert, (tape) => {
            dataTapes.push(tape);
        });
        dataTapeDependencies = utils.removeDependencies({
            dataTapeDependencies,
            dependenciesToRemove: dependenciesForRemoval,
        });
    });
    utils.ensureNoDuplicateDependencies({
        functionName: 'addAssignedLoanTapeArtifacts',
        dbGraph: {
            dataTapes,
            dataTapeDependencies,
        },
    });
    return { dataTapeDependencies, dataTapes };
};
exports.addAssignedLoanTapeArtifacts = addAssignedLoanTapeArtifacts;
const removeAssignedLoanTapeArtifacts = (graph, { loanTapeTypeMap }) => {
    const cfToLpMap = mesh.createCfToLpMap({
        outputArtifacts: utils.filterReceivableResponseTapes(graph),
        inputArtifacts: utils.filterAssignedLoanTapes(graph),
        dataTapeDependencies: graph.dataTapeDependencies,
    });
    const generatedToResponse = (0, loanTapeDependencies_1.createGeneratedLoanTapeToReceivableResponseTapeDependencies)({
        cfToLpMap,
        loanTapeTypeMap,
        dataTapes: graph.dataTapes,
    });
    const masterTapes = utils.filterMasterLoanTapes(graph);
    const masterToResponse = generatedToResponse.map((edge) => {
        const generated = utils.findArtifactById({
            dataTapes: graph.dataTapes,
            artifactId: edge.inputArtifactId,
        });
        const master = masterTapes.find((tape) => tape.configuration.generatedMasterLoanTapeArtifactSlug ===
            generated.artifactSlug);
        (0, common_1.finleyAssert)(master, `Master loan tape must exist for ${generated.artifactSlug}`);
        return {
            inputArtifactId: master.id,
            outputArtifactId: edge.outputArtifactId,
        };
    });
    const { dataTapes, dataTapeDependencies } = (0, helpers_1.removeNodesAndIncidentEdges)(graph, [
        ...utils.filterAssignedLoanTapes(graph),
        ...utils.filterReceivableResponseTapePreviews(graph),
    ].map(({ id }) => id));
    return {
        dataTapes,
        dataTapeDependencies: [...dataTapeDependencies, ...masterToResponse],
    };
};
exports.removeAssignedLoanTapeArtifacts = removeAssignedLoanTapeArtifacts;
exports.syntheticProcess = {
    toDb: (dbGraph, { loanTapeTypeMap }) => (0, exports.addAssignedLoanTapeArtifacts)({ dbGraph, loanTapeTypeMap }),
    fromDb: exports.removeAssignedLoanTapeArtifacts,
};
//# sourceMappingURL=assignedLoanTape.js.map